import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
// import polygons from './municities-province-ph133900000.0.1.json';
//  const options = {
//   fillColor: "lightblue",
//   fillOpacity: 0,
//   strokeColor: "red",
//   strokeOpacity: 1,
//   strokeWeight: 2,
//   clickable: false,
//   draggable: false,
//   editable: false,
//   geodesic: false,
//   zIndex: 1
// }

const DashboardMapContainer = ({ data }) => {


  return (
    <div className="dashboard-card">
      <div className="row mb-3">
        <div className="col-12">
          <div className="main-text">Business Locations</div>
        </div>
        <div className="col-12">
          <LoadScript
            googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAP_KEY}
          >
            <GoogleMap
              mapContainerStyle={{
                width: '100%',
                height: '600px'
              }}
              center={{
                lat: 14.4445,
                lng: 120.9939
              }}
              zoom={13}
            >
              {data.map(x => {
                const [lat,lng] = get(x, 'pinned_geolocation').split(',')
                return (
                  <Marker 
                    title={get(x, 'business_name')}
                    position={{
                      lat: +lat, 
                      lng: +lng
                    }} 
                  /> 
                )
              })}
              {/* {get(polygons, 'features').map(item => {
                
                const paths = get(item, 'geometry.coordinates.0').map(x => {

                  const [lng, lat] = x
                  
                  return {
                    lat: +lat, 
                    lng: +lng
                  }
                })
                
                return (
                  <Polygon 
                    paths={paths}
                    options={options}
                  />
                )
              })} */}
              
            </GoogleMap>
          </LoadScript>
        </div>
      </div>
    </div>
    
  )
}

DashboardMapContainer.defaultProps = {
  data: []
}

DashboardMapContainer.propTypes = {
  data: PropTypes.instanceOf(Array)
}

export default DashboardMapContainer